import getJwt from 'core/axios/getJwt';

const addBearer = ({ request, newToken }) => {
  const token = newToken || getJwt();
  if (
    token &&
    (!request || !request.headers || !request.headers.Authorization)
  ) {
    request.headers = request.headers || {};
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
};

export default addBearer;
